import { IcSearch } from '@assets/icons/32x32';
import { Button, For, HStack, Icon, Input, InputGroup, VStack } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';

import { isHalfActiveCategory } from '../monitoring.utils';
import { useMonitoringContext } from '../MonitoringContext';

export default function CategoryFilter() {
  const { formatMessage } = useIntl();
  const { state, toggleCategory, setName } = useMonitoringContext();
  const { categories } = state;

  return (
    <VStack gap={2} paddingX={2} paddingY={3} alignItems="start" width="100%" backgroundColor="neutral.850">
      {categories.size > 1 && (
        <HStack width="100%" gap={1}>
          <For each={Array.from(categories.entries())}>
            {([category, value]) => (
              <Button
                variant="toggle"
                size="toggleM"
                flex={1}
                key={category}
                data-active={value}
                data-half-active={!value && isHalfActiveCategory(category, state.ladTypes, state.perimTypes)}
                onClick={() => toggleCategory(category)}
              >
                <FormattedMessage id={`components.monitoring.filter.${category}`} />
              </Button>
            )}
          </For>
        </HStack>
      )}
      <InputGroup
        endElement={<Icon boxSize="24px" color="neutral.300" as={IcSearch} />}
        endElementProps={{ paddingInline: 2 }}
      >
        <Input
          placeholder={formatMessage({ id: 'components.monitoring.filter.search' })}
          style={{
            paddingInlineEnd: '52px',
          }}
          value={state.name}
          onChange={(event) => setName(event.target.value)}
        />
      </InputGroup>
    </VStack>
  );
}
